import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PanelEffects } from './panel.effects';
import { reducer, initialState } from './panel.reducer';
import { createWorkspaceScopedSyncReducer } from '../local-storage-sync';
import { PanelState } from './panel.state';

const syncMetaReducer = createWorkspaceScopedSyncReducer<PanelState>({
  keys: ['activePanelViews', 'alignState', 'sectionSizes'],
  rehydrate: true,
  storage: localStorage,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('panel', reducer, { initialState, metaReducers: [syncMetaReducer] }),
    EffectsModule.forFeature([PanelEffects]),
  ],
  providers: [PanelEffects],
})
export class PanelStoreModule {}
